/* eslint-disable no-unused-vars */
import wallstructuresService from '../services/wallstructures.service';

const initialState = { wallstructures: null };

export const wallstructures = {
    namespaced: true,
    state: initialState,
    actions: { 
        async getWallStructures({ commit }, options) {
            const wallstructures = await wallstructuresService.getWallStructures(options);
            commit('getWallStructuresSuccess', wallstructures);
        },
    },
    mutations: {
        getWallStructuresSuccess(state, wallstructures) {
            state.wallstructures = wallstructures;
        },
    },
    getters: {
        getWallStructuresData(state) {
            return state.wallstructures?.data;
        },
        getWallStructuresMeta(state) {
            return state.wallstructures?.meta;
        },
    }
}

